export class KeyCodes {
  public static TAB = 9;
  public static CLEAR = 12;
  public static RETURN = 13;
  public static ENTER = 13;
  public static SHIFT = 16;
  public static CONTROL = 17;
  public static ALT = 18;
  public static OPTION = 18;
  public static PAUSE_BREAK = 19;
  public static CAPS_LOCK = 20;
  public static ESCAPE = 27;
  public static SPACE_BAR = 32;
  public static PAGE_UP = 33;
  public static PAGE_DOWN = 34;
  public static END = 35;
  public static HOME = 36;
  public static LEFT_ARROW = 37;
  public static UP_ARROW = 38;
  public static RIGHT_ARROW = 39;
  public static DOWN_ARROW = 40;
  public static INSERT = 45;
  public static DELETE = 46;
  public static NUMPAD_ASTERISK = 106;
  public static NUMPAD_PLUS = 107;
  public static NUMPAD_DASH = 109;
  public static NUMPAD_MINUS = 109;
  public static NUMPAD_HYPHEN = 109;
  public static NUMPAD_PERIOD = 110;
  public static NUMPAD_FORWARD_SLASH = 111;
  public static NUM_LOCK = 144;
  public static SCROLL_LOCK = 145;
  public static MY_COMPUTER = 182;
  public static MY_CALCULATOR = 183;
  public static SEMICOLON = 186;
  public static EQUALS = 187;
  public static COMMA = 188;
  public static DASH = 189;
  public static MINUS = 189;
  public static HYPHEN = 189;
  public static PERIOD = 190;
  public static FORWARD_SLASH = 191;
  public static BACKTICK = 192;
  public static LEFT_BRACKET = 219;
  public static BACKSLASH = 220;
  public static RIGHT_BRACKET = 221;
  public static APOSTROPHE = 222;
}

